var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPersonalConcierge = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9,20.76a.63.63,0,0,0,.62.63h20a.63.63,0,0,0,.62-.63c0-2.6-1-3.74-3.43-3.74H5.33C2.86,17,1.9,18.16,1.9,20.76Zm11.22-14c5.47.23,8.73,3.64,8.73,8.4a.62.62,0,0,1-.62.62H3.77a.62.62,0,0,1-.62-.62c0-4.76,3.26-8.17,8.73-8.4V4.86H10.32A.31.31,0,0,1,10,4.55V3.93a.31.31,0,0,1,.31-.32h4.36a.31.31,0,0,1,.31.32v.62a.31.31,0,0,1-.31.31H13.12V6.75Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPersonalConcierge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Personal_Concierge.17702c7d.svg";
export { ForwardRef as ReactComponent };